import React from 'react';
import { useIntl, useHistory } from 'umi';
import './index.scss';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

export default function App(props: any) {
  const { isNewGame, entityType, setVisible } = props;
  const { formatMessage } = useIntl();
  const history = useHistory();

  const handleFollowGames = () => {
    const entityTypeMapping = {
      mobile: '/intelligence/topCharts/mobileGames',
      pc: '/intelligence/topCharts/pcGames',
      console: '/intelligence/topCharts/consoleGames',
      company: '/intelligence/topCharts/companies',
    } as any;

    let baseurl = entityTypeMapping[entityType] || '';

    const followGameUrl =
      isNewGame && entityType !== 'company' ? `${baseurl}/NewRelease` : baseurl;
    if (followGameUrl) {
      history.push(followGameUrl);
    }
  };

  //No following games yet, let's Follow some games/companies.
  return (
    <div className="following-nofollow-box">
      <span>
        {formatMessage(
          { id: `dbi_info_nofollowing_lets` },
          {
            type: formatMessage({
              id:
                entityType === 'company'
                  ? `dbi_info_companies`
                  : 'dbi_info_games',
            }),
            follow: (
            <span 
              className="following-followgames-text" 
              onClick={()=> setVisible?.(true)}>
              {formatMessage(
                { id: `dbi_info_followsome_game` },
                {
                  type: formatMessage({
                    id:
                      entityType === 'company'
                        ? `dbi_info_companies`
                        : 'dbi_info_games',
                  }),
                },
              )}
            </span>
            )
          }
        )}
      </span>
      {/* {locale === LANGUAGE_CN ? '' : <>&nbsp;</>}
      <span className="following-followgames-text" onClick={()=> {}}>
        {formatMessage(
          { id: `dbi_info_followsome_game` },
          {
            type: formatMessage({
              id:
                entityType === 'company'
                  ? `dbi_info_companies`
                  : 'dbi_info_games',
            }),
          },
        )}
      </span> */}
      <span>&nbsp;{formatMessage({
          id: 'dbi_info_follow_top_charts'
        },
        {
          type: <span 
            className="following-followgames-text" 
            onClick={handleFollowGames}>
          {formatMessage({id: 'dbi_top_charts'})}
          </span>,
          games: formatMessage({
            id:
              entityType === 'company'
                ? `dbi_info_companies`
                : 'dbi_info_games',
          }),
          game: formatMessage({
            id:
              entityType === 'company'
                ? `dbi_company_lower`
                : 'dbi_info_games',
          })
        }
        )}
      </span>
    </div>
  );
}
